import React from 'react';
import { useTheme } from '@emotion/react';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import icons from '@bbkFunnelUtils/icons';

import './overlay.scss';

export const LoadingOverlay: ReactFCC<{
  opaque?: boolean;
  opaqueFull?: boolean;
  message?: React.ReactNode;
}> = ({ opaque, opaqueFull, message = 'Loading...' }) => {
  const theme = useTheme() as EmotionTheme;
  return (
    <div
      className="bbk-funnel-loading-overlay"
      css={{
        color: theme.primaryColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: opaqueFull
          ? 'rgba(255,255,255,1)'
          : opaque
            ? 'rgba(255,255,255,0.8)'
            : 'none',
      }}
    >
      <span className="tw-inline-flex tw-items-center tw-rounded tw-bg-white tw-p-4 tw-text-lg tw-font-semibold tw-text-neutral-700">
        {icons.loader} {message}
      </span>
    </div>
  );
};
